var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 3,
    viewBox: "0 0 13 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3C1.10218 3 0.720644 2.84196 0.43934 2.56066C0.158035 2.27936 0 1.89782 0 1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0C1.89782 0 2.27936 0.158035 2.56066 0.43934C2.84196 0.720644 3 1.10218 3 1.5C3 1.89782 2.84196 2.27936 2.56066 2.56066C2.27936 2.84196 1.89782 3 1.5 3ZM6.5 3C6.10218 3 5.72064 2.84196 5.43934 2.56066C5.15804 2.27936 5 1.89782 5 1.5C5 1.10218 5.15804 0.720644 5.43934 0.43934C5.72064 0.158035 6.10218 0 6.5 0C6.89782 0 7.27936 0.158035 7.56066 0.43934C7.84196 0.720644 8 1.10218 8 1.5C8 1.89782 7.84196 2.27936 7.56066 2.56066C7.27936 2.84196 6.89782 3 6.5 3ZM11.5 3C11.1022 3 10.7206 2.84196 10.4393 2.56066C10.158 2.27936 10 1.89782 10 1.5C10 1.10218 10.158 0.720644 10.4393 0.43934C10.7206 0.158035 11.1022 0 11.5 0C11.8978 0 12.2794 0.158035 12.5607 0.43934C12.842 0.720644 13 1.10218 13 1.5C13 1.89782 12.842 2.27936 12.5607 2.56066C12.2794 2.84196 11.8978 3 11.5 3Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalMore);
export default __webpack_public_path__ + "static/media/horizontal_more.813e6aba6694cd41d9e37ab17dd15d59.svg";
export { ForwardRef as ReactComponent };